type ComponentImport<T = unknown> = () => Promise<{ default: T }>;

const lazyRetry = function <T>(componentImport: ComponentImport<T>): Promise<{ default: T }> {
  return new Promise((resolve, reject) => {
    const hasRefreshed = JSON.parse(window.sessionStorage.getItem('retry-lazy-refreshed') ?? 'false') as boolean;
    componentImport()
      .then((component) => {
        window.sessionStorage.setItem('retry-lazy-refreshed', 'false');
        resolve(component);
      })
      .catch((error) => {
        alert('The app was just updated. Refreshing to get the latest version...');
        if (!hasRefreshed) {
          window.sessionStorage.setItem('retry-lazy-refreshed', 'true');
          return window.location.reload();
        }
        reject(error);
      });
  });
};

export default lazyRetry;
